<template>
  <div id="app">
    <div class="fixed">
      <NavigationBar :title="title" />
      <CategorySwitch :cur-category-id="categoryId" :categories="categoryList" @category-switch="_categorySwitch" />
    </div>
    <div class="flow" :class="{ 'app-pad' : appStyle, 'weixin-pad' : weixinStyle }">
      <div v-if="loading" class="loading"><i /><span>正在加载...</span></div>
      <div v-if="categoryId === 0" class="category-0">
        <RecommendFocus
          :has-attention="categoryList[categoryIdx].flow.hasAttention"
          :has-more="categoryList[categoryIdx].flow.hasMoreAttention"
          :brand-views="categoryList[categoryIdx].flow.bzBrandViews"
          @toggle-attention="(idx)=>_toggleAttention('recomend',idx)"
        />
        <!-- 未关注未收藏时显示所有类目前三品牌 引导关注列表 -->
        <div v-if="!categoryList[categoryIdx].flow.hasAttention && !categoryList[categoryIdx].flow.hasCollect" class="category-attention-list">
          <div
            v-for="(item,index) in newBzBrandResults"
            :key="item.categoryId"
            class="category-attention-list-item"
          >
            <div v-if="item.children.length>0" class="item-title">{{ item.categoryName }}类目</div>
            <div class="brandTop3-list">
              <AttentionItem
                v-for="(branditem,chilIndex) in item.children"
                :key="branditem.brandId"
                :attention-item="branditem"
                @toggle-attention="_toggleAttention('attentionList',index,chilIndex)"
              />
            </div>
          </div>
        </div>
        <!-- 已关注未收藏 -->
        <InformationFlowList v-if="categoryList[categoryIdx].flow.flowTotalCount && categoryList[categoryIdx].flow.hasAttention && !categoryList[categoryIdx].flow.hasCollect" :category-index="true" :flow-title="'您可能感兴趣的文章'" :update-time="firstRequestTime" :flow-list="categoryList[categoryIdx].flow.flowViews || []" :total-count="categoryList[categoryIdx].flow.flowTotalCount" :axios-url="axiosUrl" />
        <!-- 已关注已收藏 -->
        <InformationFlowList v-if="categoryList[categoryIdx].flow.flowTotalCount && categoryList[categoryIdx].flow.hasAttention && categoryList[categoryIdx].flow.hasCollect" :category-index="true" :flow-title="'已收藏的文章'" :update-time="firstRequestTime" :flow-list="categoryList[categoryIdx].flow.flowViews || []" :total-count="categoryList[categoryIdx].flow.flowTotalCount" :axios-url="axiosUrl" />
        <!-- 未关注已收藏 -->
        <InformationFlowList v-if="categoryList[categoryIdx].flow.flowTotalCount && !categoryList[categoryIdx].flow.hasAttention && categoryList[categoryIdx].flow.hasCollect" :category-index="true" :flow-title="'已收藏的文章'" :update-time="firstRequestTime" :flow-list="categoryList[categoryIdx].flow.flowViews || []" :total-count="categoryList[categoryIdx].flow.flowTotalCount" :axios-url="axiosUrl" />
      </div>
      <div v-if="categoryId === 1" class="category-1">
        <InformationFlowList v-if="categoryList[categoryIdx].flow.flowTotalCount" :update-time="firstRequestTime" :category-index="true" :flow-list="categoryList[categoryIdx].flow.flowViews || []" :total-count="categoryList[categoryIdx].flow.flowTotalCount" :axios-url="axiosUrl" />
      </div>
      <div v-if="categoryId !== 0 && categoryId !== 1 " class="category-else">
        <div v-if="categoryList[categoryIdx].flow.bzBrandResults && categoryList[categoryIdx].flow.bzBrandResults.length > 0" class="brand-rank">
          <div class="rank-top">
            <span class="rank-title">{{ categoryName }}-品牌排行榜</span>
            <span class="more" @click="_tobrandMore(categoryId)">
              更多
              <i class="icon" />
            </span>
          </div>
          <ul class="rank-list">
            <li
              v-for="(item, index) in categoryList[categoryIdx].flow.bzBrandResults.slice(0, 3)"
              :key="item.brandId"
              @click="_tobrandIndex(item.brandId, index)"
            >
              <div class="logo-box">
                <img :src="item.brandLogo" class="logo">
                <div v-if="index == 0" class="rank-box one" />
                <div v-if="index == 1" class="rank-box two" />
                <div v-if="index == 2" class="rank-box three" />
              </div>
              <div class="brand-title single-line-ellipsis">{{ item.brandName }}</div>
              <div class="orange">
                <span class="gray">门店数：</span>
                {{ item.shopCount }}
              </div>
              <div class="store-num">逛品牌</div>
            </li>
          </ul>
        </div>
        <div class="style">
          <InformationFlowList v-if="categoryList[categoryIdx].flow.flowTotalCount" :update-time="firstRequestTime" :category-index="true" :flow-list="categoryList[categoryIdx].flow.flowViews || []" :total-count="categoryList[categoryIdx].flow.flowTotalCount" :axios-url="axiosUrl" />
        </div>
      </div>
      <div v-if="!categoryList[categoryIdx].flow.flowTotalCount && !loading" class="no-more">没有更多数据了</div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import { Toast, List, Loading } from 'vant';
import NavigationBar from '@/components//NavigationBar.vue';
import RecommendFocus from '@/components//RecommendFocus.vue';
import CategorySwitch from '@/components/CategorySwitch.vue';
import AttentionItem from '@/components/AttentionItem.vue';
import InformationFlowList from '@/components/InformationFlowList.vue';
import nativeBrandIndex from '../../filters/nativeBrandIndex';
import { isApp, isAndroid, isWeiXin } from '@/lib/compatibility';
import Util from '../../lib/util';

Vue.use(Toast).use(List).use(Loading);

export default {
  name: 'App',
  components: {
    NavigationBar,
    RecommendFocus,
    CategorySwitch,
    AttentionItem,
    InformationFlowList,
  },
  data() {
    return {
      categoryId: 1,
      categoryName: '推荐',
      categoryIdx: 1, // 在类目列表中的索引值
      title: '品牌大全',
      page: 1,
      pageSize: 10,
      loading: false,
      categoryList: [], // 类目列表
      newBzBrandResults: [], // 未关注品牌未收藏文章-展示每个类目下品牌热度排前三的品牌-重组后数据
      firstRequestTime: globalData.frt,
      appStyle: false,
      weixinStyle: false,
      attentionsMd: null, // 当前关注的品牌组成的md码，当无更新时页面不做数据更新
    };
  },
  computed: {
    axiosUrl() {
      return `${globalRootUrl}ppzq/flow/${this.categoryId}`;
    },
  },

  created() {
    this._initData();
  },
  mounted() {
    this._initMd();
    if (isApp) {
      window.onPageResume = this._onRefresh;
    } else if (!isWeiXin) {
      window.onpageshow = this._onRefresh;
    }
  },

  methods: {
    _initData() {
      if (isApp) this.appStyle = true;
      else this.appStyle = false;
      if (isWeiXin) this.weixinStyle = true;
      else this.weixinStyle = false;
      const params = Util.parseSearchParams(window.location.search);
      if (params.fr === 'apphome') {
        sessionStorage.removeItem('brandListCategoryId');
      }
      const storageCategoryId = sessionStorage.getItem('brandListCategoryId');
      this.categoryId = storageCategoryId ? Number(storageCategoryId) : Number(globalData.curCategoryId);
      this.categoryList = globalData.categories.map(t => ({
        ...t,
        categoryName: t.categoryId === 1 ? '推荐' : t.categoryName,
        categoryPy: t.categoryId === 1 ? 'tuijian' : t.categoryPy,
        flow: t.categoryId === globalData.curCategoryId ? {
          ...globalData.flow,
          bzBrandViews: t.categoryId === 0 ? globalData.flow.bzBrandViews.map(sub => ({ ...sub, success: globalData.flow.hasAttention })) : globalData.flow.bzBrandViews,
        } : {
          hasAttention: false,
          hasCollect: false,
          bzBrandViews: [],
          bzBrandResults: [],
          flowViews: [],
          flowTotalCount: 0,
          frt: null,
          categoryId: t.categoryId,
        },
      }));
      if (this.categoryId !== 1 && Number(storageCategoryId) !== globalData.curCategoryId) {
        this.loading = true;
        this._getFlow();
      }
      this.categoryName = this._toGetNameById(this.categoryId);
      this.categoryIdx = this._getIndexById(this.categoryId);
      this._reformBzBrandResults();
    },

    _getAttentionsMd() {
      return new Promise((resolve, reject) => {
        axios.get(`${globalRootUrl}brand/attentions/md/`).then((res) => {
          resolve(res.data);
        }).catch((err) => {
          reject(err);
        });
      });
    },

    async _initMd() {
      const mdrs = await this._getAttentionsMd();
      this.attentionsMd = mdrs.data ? mdrs.data : null;
    },

    /**
     * 判断关注品牌md是否有变，有变则刷新数据
     */
    async _onRefresh() {
      if (this.categoryId === 0) {
        const mdrs = await this._getAttentionsMd();
        const refresh = mdrs.data !== this.attentionsMd;
        if (mdrs.errno !== -1 && refresh) {
          this.loading = true;
          this._getFlow();
        }
      }
    },

    _categorySwitch(category) {
      this.categoryId = category.categoryId;
      this.categoryName = category.categoryName;
      this.categoryIdx = this._getIndexById(this.categoryId);
      window.scrollTo(0, 0);
      this.loading = true;
      this._getFlow();
    },

    _getFlow() {
      const param = {
        params: {
          page: this.page,
          pageSize: this.pageSize,
          frt: this.firstRequestTime,
          timestamp: new Date().getTime(),
        },
      };
      if (isApp && isAndroid && typeof (Device) !== 'undefined') {
        const deviceData = JSON.parse(Device.getInfo());
        param.headers = {
          appId: deviceData.appId,
          userId: deviceData.userId,
          deviceId: deviceData.id,
          appVersion: deviceData.appVersion,
          devicePlatform: deviceData.platform,
          sessionId: deviceData.sessionId,
          app_channel: deviceData.channel,
          package: deviceData.package,
        };
      }
      axios.get(`${this.axiosUrl}`, param)
        .then((res) => {
          const { data } = res;
          if (!data) throw new Error('获取信息流异常');
          this.loading = false;
          if (data.categoryId === this.categoryId) {
            this.categoryList[this.categoryIdx].flow = {
              ...data,
              flowTotalCount: data.flowTotalCount || 0,
              bzBrandViews: this.categoryId === 0 ? data.bzBrandViews.map(sub => ({ ...sub, success: data.hasAttention })) : (data.bzBrandViews || []),
            };
            if (this.categoryId === 0 && data.bzBrandResults) { this._reformBzBrandResults(); }
            if (this.categoryId === 0) this.attentionsMd = data.attentionsMd;
          }
        })
        .catch((err) => {
          console.warn(err);
          Toast.fail('服务器开小差啦~');
        });
    },

    _tobrandIndex(brandId) {
      window.location.href = nativeBrandIndex(
        `${globalRootUrl}ppzq/brand-${brandId}/`,
      );
    },

    _tobrandMore(categoryId) {
      window.location.href = `${globalRootUrl}ppzq/ranking/${categoryId}/?isBrand=true`;
    },

    /**
     * 关注品牌接口请求
     */
    _AttentionRequest(url, successMsg, errMsg) {
      return new Promise((resolve, reject) => {
        axios.post(url).then((data) => {
          const res = data.data;
          if (res && res.errno === -1) {
            window.location.href = res.url;
            return;
          }
          if (res && res.code === 1) {
            resolve('success');
            Toast({
              message: successMsg,
              duration: 800,
            });
          }
        }).catch((err) => {
          reject(err);
          Toast.fail(errMsg);
          Toast({
            message: errMsg,
            duration: 800,
          });
        });
      });
    },

    /**
     * type:'recomend'为推荐关注横向列表；'attentionList'为未关注未收藏时所有类目前三品牌关注竖向列表
     * 关注类目下 品牌列表点击关注按钮切换关注状态
     */
    _toggleAttention(type, idx, subIdx) {
      const attentionObj = type === 'recomend' ? this.categoryList[0].flow.bzBrandViews[idx] : this.newBzBrandResults[idx].children[subIdx];
      const url = `${globalRootUrl}brand/attention${attentionObj.success ? '/cancel' : ''}/${attentionObj.brandId}`;
      const successMsg = attentionObj.success ? '取消成功！' : '关注成功！';
      const errMsg = attentionObj.success ? '取消失败，请重试。' : '关注失败，请重试。';
      this._AttentionRequest(url, successMsg, errMsg).then((res) => {
        if (res === 'success') {
          attentionObj.success = !attentionObj.success;
        }
      });
    },

    /**
     * 根据id取出数组中的对象对应的name
     */
    _toGetNameById(categoryId) {
      const categoryCurrent = this.categoryList.find(
        item => item.categoryId === categoryId,
      );
      return categoryCurrent.categoryName;
    },

    /**
     * 根据categoryId查找在数组中对应的索引值
     */
    _getIndexById(id) {
      return this.categoryList.findIndex(t => t.categoryId === id);
    },

    /**
     * 重组globalData.bzBrandResults
     */
    _reformBzBrandResults() {
      const arr = this.categoryList[0].flow.bzBrandResults;
      if (arr) {
        const result = this.categoryList.map(({ categoryId, categoryName }) => ({
          categoryId,
          categoryName,
          children: arr.filter(x => x.categoryId === categoryId).map(y => ({ ...y, success: false })),
        }));
        this.newBzBrandResults = result;
      } else {
        this.newBzBrandResults = [];
      }
    },
  },
};
</script>

<style lang="less">
@import "../../style/common.less";
@icon-item: 1/45 * 100%;

.fixed {
  position: fixed;
  width: 100%;
  box-sizing: border-box;
  z-index: 9;
  background: #fff;
  max-width: 750px;
}

.flow {
  padding-top: 228px;

  &.app-pad {
    padding-top: 118px !important;
  }

  &.weixin-pad {
    padding-top: 108px !important;
  }
}

.loading {
  text-align: center;
  padding: 20px;

  i {
    display: inline-block;
    width: 40px;
    height: 40px;
    background: url(//mued3.jia.com/image/mobile/activity/loading.gif) no-repeat center;
    margin-right: 10px;
    vertical-align: middle;
    background-size: 100% auto;
  }

  span {
    font-size: 28px;
    line-height: 40px;
    color: #999;
  }
}

#app {
  background: #fff;
}

.brand-rank {
  padding-top: 50px;
  margin: 0 28px;

  .rank-top {
    display: flex;
    flex-flow: nowrap;
    align-items: center;
    height: 58px;

    .rank-title {
      font-size: 42px;
      font-weight: bold;
      color: #000028;
      line-height: 60px;
      flex: 1;
    }

    .more {
      margin: 0;
      color: #848494;
      font-size: 26px;
      line-height: 40px;
      position: relative;
      font-weight: 400 !important;

      .icon {
        width: 10px;
        margin-left: 13px;

        &::after {
          content: "";
          position: absolute;
          top: 50%;
          right: 0;
          margin-top: -6px;
          border-top: 4px solid #9a9aa7;
          border-right: 4px solid #9a9aa7;
          width: 7px;
          height: 7px;
          border-radius: 2px;
          transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
        }
      }
    }
  }

  .rank-list {
    display: flex;
    flex-flow: row nowrap;
    padding-bottom: 40px;
    border-bottom: 1px solid #ecebeb;
    margin-top: 42px;

    li {
      text-align: center;
      margin-right: 29px;

      &:last-child {
        margin-right: 0;
      }

      a {
        display: block;
      }

      .logo-box {
        width: 212px;
        height: 212px;
        background: #fff;
        border: 2px solid #e0e0e0;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        position: relative;

        .logo {
          width: 160px;
          height: auto;
        }

        .rank-box {
          position: absolute;
          top: -9px;
          left: 20px;
          width: 72px;
          height: 37px;

          &.one {
            background: url("../../images/no.1@2x.png") no-repeat;
            background-size: 72px auto;
          }

          &.two {
            background: url("../../images/no.2@2x.png") no-repeat;
            background-size: 72px auto;
          }

          &.three {
            background: url("../../images/no.3@2x.png") no-repeat;
            background-size: 72px auto;
          }
        }

        .right-icon {
          display: block;
          width: 0;
          height: 0;
          border-right: 12px solid transparent;
          position: absolute;
          left: 124px;
          top: -13;

          &.icon-one {
            border-bottom: 12px solid #db5d00;
          }

          &.icon-two {
            border-bottom: 12px solid #646b92;
          }

          &.icon-three {
            border-bottom: 12px solid #b48536;
          }
        }
      }
    }

    .brand-title {
      margin-top: 30px;
      font-size: 28px;
      color: #333;
      font-weight: 400 !important;
      line-height: 36px;
      text-align: center;
      width: 212px;
    }

    .orange {
      color: #333;
      font-size: 24px;
      line-height: 60px;
      margin-bottom: 3px;
      font-weight: 400 !important;
    }

    .store-num {
      color: #fff;
      font-size: 26px;
      width: 140px;
      height: 60px;
      background: linear-gradient(
        90deg,
        rgba(255, 148, 41, 1),
        rgba(255, 105, 41, 1)
      );
      border-radius: 6px;
      line-height: 60px;
      text-align: center;
      margin: 0 auto;
      font-weight: 400 !important;
    }
  }

  .more {
    margin: 58px 0 34px;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;

    .btn {
      font-size: 37px;
      color: #333;
      line-height: 58px;
      background: #fff;
      padding: 24px 135px 26px 94px;
      box-sizing: border-box;
      border: 1px solid #e0e0e0;
      border-radius: 53px;
      position: relative;

      .down {
        &::after {
          content: "";
          position: absolute;
          top: 50%;
          right: 91px;
          margin-top: -12px;
          border-right: 6px solid #333;
          border-bottom: 6px solid #333;
          width: 12px;
          height: 12px;
          border-radius: 2px;
          transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
        }
      }

      .up {
        &::after {
          content: "";
          position: absolute;
          top: 50%;
          right: 91px;
          margin-top: -6px;
          border-left: 6px solid #333;
          border-top: 6px solid #333;
          width: 12px;
          height: 12px;
          border-radius: 2px;
          transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
        }
      }
    }
  }
}

// 未关注未收藏 全部类目各前三品牌列表样式
.category-attention-list {
  margin: 0 28px;

  .category-attention-list-item {
    .item-title {
      font-size: 36px;
      font-weight: bold;
      color: #000028;
      line-height: 60px;
      margin-bottom: 40px;
      margin-top: 80px;
    }
  }
}

.no-more {
  color: #969799;
  text-align: center;
  padding: 40px 0;
  font-size: 28px;
}
</style>
